// Types for items and revisions
export interface Revision {
  id: string
  itemId: string
  encryptedData: string
  createdAt: string
}

export interface Item {
  id: string
  type: string
  createdAt: string
  updatedAt: string
  revisions: Revision[]
}

// Interface for decrypted item data
export type DecryptedItemData = any

// Type for offline data storage
export interface StoredData {
  items: Record<string, Item>
}

// Storage adapter interface
export interface ClientDataStorageAdapter {
  getItem(key: string): Promise<string | null>
  setItem(key: string, value: string): Promise<void>
  removeItem(key: string): Promise<void>
  storageKey: string
}

// Constants for storage keys
export const LAST_SYNC_TIMESTAMP_KEY = "taskfortress:lastSyncTimestamp"
export const OFFLINE_DATA_KEY = "taskfortress:offlineData"

// Type for update data to be used with batch updates
export interface ItemUpdateData {
  itemId: string
  type: string
  content: any
}

// User settings schema
export enum ThemeEnum {
  SYSTEM = "system",
  LIGHT = "light",
  DARK = "dark",
}

export enum ContentTypeEnum {
  TASKS = "tasks",
  NOTES = "notes",
}

export enum DateFormatEnum {
  ISO = "yyyy-mm-dd",
  EU = "dd-mm-yyyy",
  US = "mm-dd-yyyy",
}

export enum FirstDayOfWeekEnum {
  SUNDAY = 0,
  MONDAY = 1,
}

export interface UserSettings {
  lastViewedNote?: string
  theme?: ThemeEnum
  dateFormat?: DateFormatEnum
  defaultStartPage?: ContentTypeEnum
  sidebarWidth?: number
  fontSize?: number
  lastSelectedNoteTag?: string | null
  lastSelectedTaskTag?: string | null
  sidenavCollapsed?: boolean
  firstDayOfWeek?: FirstDayOfWeekEnum
  // Add more settings as needed
}

// Default user settings
export const DEFAULT_USER_SETTINGS: UserSettings = {
  theme: ThemeEnum.SYSTEM,
  dateFormat: DateFormatEnum.ISO,
  defaultStartPage: ContentTypeEnum.TASKS,
  sidebarWidth: 72,
  fontSize: 16,
  lastSelectedNoteTag: null,
  lastSelectedTaskTag: null,
  sidenavCollapsed: false,
  firstDayOfWeek: FirstDayOfWeekEnum.MONDAY,
}
